<template>
  <el-table-column
    v-if="element.isProp()"
    :prop="options.prop"
    :label="options.label"
    :width="options.width"
    :align="options.align"
    :class-name="options.className"
  ></el-table-column>
  <el-table-column
    v-else
    :label="options.label"
    :width="options.width"
    :align="options.align"
    :class-name="options.className"
  >
    <template v-slot="scope">
      <component :is="options.prop" v-bind="{...options, row: scope.row, rowId: scope.row.id}"></component>
    </template>
  </el-table-column>
</template>

<script>
import BillHistory from './BillHistory'
import ColumnAddToCart from './ColumnAddToCart'
import ColumnPriceDropDown from './ColumnPriceDropDown'
import ColumnPriceDropDownWithInput from './ColumnPriceDropDownWithInput'
import ColumnProductCodeSelectPopper from './ColumnProductCodeSelectPopper'
import ColumnProductNameInput from './ColumnProductNameInput'
import ColumnStockDropDown from './ColumnStockDropDown'
import ColumnStockDropDownSingleStk from './ColumnStockDropDownSingleStk'
import ColumnLocationDialog from './ColumnLocationDialog'
import ColumnProductCodePopover from './ColumnProductCodePopover'
import ColumnDeliverStatus from './ColumnDeliverStatus'
import ColumnShippingType from './ColumnShippingType'
import ColumnInputQty from './ColumnInputQty'
import ColumnLineAmount from './ColumnLineAmount'
import ColumnInputDesc from './ColumnInputDesc'
import ColumnLineTaxType from './ColumnLineTaxType'
import ColumnInputInQty from './ColumnInputInQty'
import ColumnInputSysQty from './ColumnInputSysQty'
import ColumnProductCostPrice from './ColumnProductCostPrice'
import ColumnLineQtyBalance from './ColumnLineQtyBalance'
import ColumnShow from './ColumnShow'
import ColumnIconShow from './ColumnIconShow'
import ColumnViewBtn from './ColumnViewBtn'
import ColumnViewBaseinfoBtn from './ColumnViewBaseinfoBtn'
import { makeTable } from '../providers/element'

export default {
  name: 'ElementCreatorTable',
  components: {
    BillHistory,
    ColumnAddToCart,
    ColumnPriceDropDown,
    ColumnPriceDropDownWithInput,
    ColumnProductCodeSelectPopper,
    ColumnProductNameInput,
    ColumnStockDropDown,
    ColumnStockDropDownSingleStk,
    ColumnLocationDialog,
    ColumnProductCodePopover,
    ColumnDeliverStatus,
    ColumnShippingType,
    ColumnInputQty,
    ColumnLineAmount,
    ColumnInputDesc,
    ColumnLineTaxType,
    ColumnInputInQty,
    ColumnInputSysQty,
    ColumnProductCostPrice,
    ColumnLineQtyBalance,
    ColumnShow,
    ColumnIconShow,
    ColumnViewBtn,
    ColumnViewBaseinfoBtn
  },
  props: {
    config: {
      required: true
    }
  },
  data () {
    return {
      element: makeTable(this.config)
    }
  },
  computed: {
    options () {
      return this.element.props()
    }
  }
}
</script>
